module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1920e91b54ab5d267aa2b9b0a5288c3c.png";